import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { getErrorMessage } from "@dune/vars";
import { privateAxios } from "../axios";
import { societiesQueryKeys } from "../query-keys/societies.query-keys";

export type CreateApiKeyResponse = {
	id: number;
	name: string;
	keyPrefix: string;
	key: string;
	allowedRoutes: string[];
	expiresAt: string;
	isActive: boolean;
	createdAt: string;
};

const createBrokerApiKey = async (
	brokerId: number,
): Promise<CreateApiKeyResponse> => {
	const { data } = await privateAxios.post<CreateApiKeyResponse>(
		`/societies/broker/${brokerId}/api-keys`,
	);
	return data;
};

export const useCreateBrokerApiKey = (brokerId: number) => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: () => createBrokerApiKey(brokerId),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: societiesQueryKeys.brokerApiKeys(brokerId),
			});
		},
		onError: (error) => {
			toast.error("Erreur lors de la création de la clé API", {
				description: getErrorMessage(error),
			});
		},
	});
};
